<template>
<div class="chapter">
<div class="inner_page">
<p class="C141"><a id="page_xxiv"></a>A<span class="small">LEC</span> F<span class="small">ORBES OF</span> H<span class="small">OWGLEN</span></p>
<p class="C269">1865</p>
<p class="C169">The Cullen Collection</p>
<p class="C271">Volume 5</p>
<p class="C251"><img alt="" height="auto" src="Images/image00245.jpeg" width="45%"/></p>
<p class="C251"><a id="page_xxv"></a><img alt="" height="auto" src="Images/image00246.jpeg" width="60%"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0008.vue?20b8f472